import React, { useState } from "react";
import { motion } from "framer-motion";

const AnimatedGrid = () => {
  const [columns, setColumns] = useState(20); // Dynamically control the number of columns
  const containerSize = window.innerWidth < 768 ? 300 : 500; // Size of the grid container
  const squareSize = containerSize / columns; // Adjust square size based on columns
  const animDelay = 0.1; // Animation delay in seconds

  // Generate grid items
  const gridItems = [];
  for (let i = 0; i < columns; i++) {
    for (let j = 0; j < columns; j++) {
      const animIndex = i + j; // Calculate animation index
      gridItems.push({ id: `${i}-${j}`, delay: animIndex * animDelay });
    }
  }

  return (
    <div>
      <div
        style={{
          display: "grid",
          gridTemplateColumns: `repeat(${columns}, ${squareSize}px)`,
          gap: "2px",
          justifyContent: "center",
          alignItems: "center",
          width: containerSize,
          height: containerSize,
          margin: "auto",
          position: "absolute",
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
          zIndex: "-4",
        }}
      >
        {gridItems.map(({ id, delay }) => (
          <motion.div
            key={id}
            style={{
              width: squareSize,
              height: squareSize,
              borderRadius: "10%",
              backgroundColor: "#0F0F11",
              boxShadow: "-2px 2px #0F0F11",
            }}
            initial={{ scale: 1 }}
            animate={{
              scale: [1, 0.8, 1],
              backgroundColor: ["#0F0F11", "#0F0F11", "#383D3E"],
            }}
            transition={{
              duration: 2, // Animation duration in seconds
              ease: "easeInOut",
              repeat: Infinity,
              repeatType: "reverse",
              delay,
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default AnimatedGrid;
